import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoginForm from '../components/auth/LoginForm';

const LoginPage = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // 如果已经登录，重定向到评估记录页面
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/evaluations');
    }
  }, [isAuthenticated, navigate]);

  // 获取来源页面或默认为评估记录页面
  // const from = location.state?.from?.pathname || '/evaluations';

  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-8rem)]">
      <div className="w-full max-w-md">
        {location.state?.message && (
          <div className="mb-4 p-3 rounded-md bg-green-100 text-green-800 text-sm">
            {location.state.message}
          </div>
        )}
        <LoginForm />
      </div>
    </div>
  );
};

export default LoginPage;
